import { NgModule } from '@angular/core';
import { MapperInjectorService } from './response-mapper/mapper-injector.service';
import { ResourceCollectionBuilderService } from './response-mapper/resource-collection-builder.service';
import { ResourceIdentifierMapperService } from './response-mapper/resource-identifier-mapper.service';
import { MediaFileMapper } from './response-mapper/resource/media-file.mapper';
import { MediaImageMapper } from './response-mapper/resource/media-image.mapper';
import { MenuMapper } from './response-mapper/resource/menu.mapper';
import { TaxonomyTermBadgeMapper } from './response-mapper/resource/taxonomy-term-badge.mapper';
import { TaxonomyTermBigIconsMapper } from './response-mapper/resource/taxonomy-term-big-icons.mapper';
import { TaxonomyTermDPPKeyAccountManagerMapper } from './response-mapper/resource/taxonomy-term-dpp-key-account-manager.mapper';
import { TaxonomyTermPDFFileMapper } from './response-mapper/resource/taxonomy-term-pdf-file.mapper';
import { TaxonomyTermServiceToolsMapper } from './response-mapper/resource/taxonomy-term-service-tools.mapper';
import { ResponseMapperService } from './response-mapper/response-mapper.service';

@NgModule({
    providers: [
        MapperInjectorService,
        ResourceCollectionBuilderService,
        ResourceIdentifierMapperService,
        ResponseMapperService,
        { provide: MapperInjectorService.tokens[MediaImageMapper.type], useClass: MediaImageMapper },
        { provide: MapperInjectorService.tokens[MediaFileMapper.type], useClass: MediaFileMapper },
        { provide: MapperInjectorService.tokens[MenuMapper.type], useClass: MenuMapper },
        { provide: MapperInjectorService.tokens[TaxonomyTermBadgeMapper.type], useClass: TaxonomyTermBadgeMapper },
        { provide: MapperInjectorService.tokens[TaxonomyTermBigIconsMapper.type], useClass: TaxonomyTermBigIconsMapper },
        { provide: MapperInjectorService.tokens[TaxonomyTermDPPKeyAccountManagerMapper.type], useClass: TaxonomyTermDPPKeyAccountManagerMapper },
        { provide: MapperInjectorService.tokens[TaxonomyTermPDFFileMapper.type], useClass: TaxonomyTermPDFFileMapper },
        { provide: MapperInjectorService.tokens[TaxonomyTermServiceToolsMapper.type], useClass: TaxonomyTermServiceToolsMapper },
    ],
})
export class JsonApiClientModule {}
